import WareNav from "../WareNav";
import { useEffect, useState } from "react";
import axios from "axios";
import Alert from "@mui/material/Alert";
import "./invoiceCheck.scss";
import { getAllStores } from "../../utils/Api";

export default function RunDispos() {
  const url = process.env.REACT_APP_DEPPLOYED;

  const [loader, setLoader] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [sites, setSites] = useState([]);
  const [scriptStatuses, setScriptStatuses] = useState({});
  const [latestRuns, setLatestRuns] = useState({});
  const [selectedSites, setSelectedSites] = useState({});

  useEffect(() => {
    getAllStores()
      .then(async (data) => {
        setSites(data);
        await fetchScriptStatuses(data);
      })
      .catch((err) => console.log(err));
    fetchLatestScriptsRun("HeadOffice", "stockIngest");
    fetchLatestScriptsRun("Warehouse", "disposable");
  }, []);

  const fetchLatestScriptsRun = async (site, type) => {
    try {
      const response = await axios.get(
        `${url}/edn/script-latest-run/${site}/${type}`
      );
      if(response.data !== "No data"){
      const latestRun = {
        result: response.data.code === 0 ? "Success" : "Failed",
        timeStarted: new Date(response.data.time_start * 1000).toLocaleString(),
        description: response.data.description || "",
      };
      setLatestRuns((prev) => ({ ...prev, [`${site}_${type}`]: latestRun }));
    }else{
      setLatestRuns((prev) => ({
        ...prev,
        [`${site}_${type}`]: { error: "No info" },
      }));
    }
    } catch {
      setLatestRuns((prev) => ({
        ...prev,
        [`${site}_${type}`]: { error: "No info" },
      }));
    }
  };

  const fetchScriptStatuses = async (sitesToCheck) => {
    const statuses = { ...scriptStatuses };
    const types = ["disposable", "Vape", "Keg"];
    for (const site of sitesToCheck) {
      for (const type of types) {
        const key =
          site.siteName === "Head Office"
            ? "HeadOffice_stockIngest"
            : `${site.siteName}_${type}`;

        try {
          const route =
            site.siteName === "Head Office"
              ? `${url}/edn/scripts-status/HeadOffice/stockIngest`
              : `${url}/edn/scripts-status/${site.siteName}/${type}`;

          const res = await axios.get(route);
          statuses[key] = res.data.run;
        } catch (err) {
          //console.warn(`Skipping unsupported script: ${site.siteName} - ${type}`);
        }
      }
    }
    setScriptStatuses(statuses);
  };

  const handleSiteChange = (e, type) => {
    const selectedSite = e.target.value;
    setSelectedSites((prev) => ({ ...prev, [type]: selectedSite }));
    fetchLatestScriptsRun(selectedSite, type);
  };

  const isScriptRunning = (site, type) =>
    scriptStatuses[`${site}_${type}`] || false;

  const runScriptNew = async (type, site) => {
    setShowAlert(false);
    if (!site) {
      setMessage("Please Select A Site!");
      setSeverity("error");
      setShowAlert(true);
      return;
    }

    setLoader(true);
    try {
      const res = await axios.get(`${url}/edn/scripts/${site}/${type}`);
      const status = res.data.status;
      setMessage(status === "success" ? "Script finished" : "Script failed");
      setSeverity(status === "success" ? "success" : "error");
    } catch {
      setMessage("There was an error starting the script");
      setSeverity("error");
    }
    setLoader(false);
    setShowAlert(true);
  };

  const renderScriptRow = (label, scriptType, site = null) => {
    const siteKey = site || selectedSites[scriptType];
    const runInfo = latestRuns[`${siteKey}_${scriptType}`];

    return (
      <tr>
        <td>
          {site ? (
            label
          ) : (
            <select
              style={{ width: "150px", padding: "5px 10px" }}
              onChange={(e) => handleSiteChange(e, scriptType)}
            >
              <option>--- Select Site ---</option>
              {sites.map((d, i) => (
                <option key={i}>{d.siteName}</option>
              ))}
            </select>
          )}
        </td>
        <td>
          <button
            style={{
              width: "150px",
              backgroundColor: isScriptRunning(siteKey, scriptType)
                ? "#FFA500"
                : "",
            }}
            onClick={() => runScriptNew(scriptType, siteKey)}
            disabled={isScriptRunning(siteKey, scriptType)}
          >
            {isScriptRunning(siteKey, scriptType) ? "In progress" : label}
          </button>
        </td>
        <td>
          {runInfo ? (
            runInfo.error ? (
              runInfo.error
            ) : (
              <>
                <div>Result: {runInfo.result}</div>
                <div>Time: {runInfo.timeStarted}</div>
                {runInfo.description && (
                  <div>Description: {runInfo.description}</div>
                )}
              </>
            )
          ) : site ? (
            "Loading..."
          ) : (
            "Select site"
          )}
        </td>
      </tr>
    );
  };

  return (
    <main style={{ height: "95vh" }}>
      <WareNav />
      <section className="dispos_main">
        <h1>Manually Run Scripts</h1>
        {!loader ? (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Site</th>
                  <th>Script</th>
                  <th>Latest run</th>
                </tr>
              </thead>
              <tbody>
                {renderScriptRow(
                  "Run Stock Ingest",
                  "stockIngest",
                  "HeadOffice"
                )}
                {renderScriptRow(
                  "Disposables Stock",
                  "disposable",
                  "Warehouse"
                )}
                {renderScriptRow("Site Disposables", "disposable")}
                {renderScriptRow("Vape Ordering", "Vape")}
                {renderScriptRow("Keg Ordering", "Keg")}
              </tbody>
            </table>
          </div>
        ) : (
          <section className="loader_container">
            <strong>Please wait, this takes about 5-10 minutes to run</strong>
            <div className="loader_circles">
              {[...Array(4)].map((_, i) => (
                <div className="circle" key={i}>
                  <div className="dot"></div>
                  <div className="outline"></div>
                </div>
              ))}
            </div>
          </section>
        )}
        {showAlert && (
          <Alert severity={severity} sx={{ marginTop: "0.5%" }}>
            {message}
          </Alert>
        )}
      </section>
    </main>
  );
}
